import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.minimumLength", function() {

    var expose = {};

    // We have to define our own minimum length directive because
    // Angular's ng-minlength doesn't return the model data if it's invalid
    // which means we can't perform intermediate checks on the data until
    // it's completely valid
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function($scope, element, attributes, controller) {

        $scope.validate = function(value) {
            var isValid;
            if (value) {
                isValid = value.length >= attributes.minimumLength;
                controller.$setValidity("minimumLength", isValid);
            }
            return value;
        };

        controller.$parsers.push($scope.validate);
        controller.$formatters.push($scope.validate);

    };

    return expose;

});
